jQuery( document ).ready(function() {
    // Check if component is added to the page
    if( jQuery('section.panorama').length ) {

        let $ = jQuery;
        $("section.panorama").each(function () {
            let $imageUrl = $(this).data('image_url');

            let container = $(this).find('.pano-container');
            let containerId = $(this).find('.pano-container').attr("id");
            let viewer = pannellum.viewer(containerId, {
                "type": "equirectangular",
                "panorama": $imageUrl,
                "autoLoad": true,
                "compass": false,
                "showControls": false,
                "autoRotate": -5,
                "hfov": 1050
            });

            let $panUp = container.find('.pan-up');
            let $panDown = container.find('.pan-down');
            let $panLeft = container.find('.pan-left');
            let $panRight = container.find('.pan-right');
            let $zoomOut = container.find('.zoom-out');
            let $zoomIn = container.find('.zoom-in');
            let $fullscreen = container.find('.fullscreen');

            $panUp.on('click', function () {
               viewer.setPitch(viewer.getPitch() + 10);
            });
            $panDown.on('click', function () {
               viewer.setPitch(viewer.getPitch() - 10);
            });
            $panLeft.on('click', function () {
               viewer.setYaw(viewer.getYaw() - 10);
            });
            $panRight.on('click', function () {
               viewer.setYaw(viewer.getYaw() + 10);
            });
            $zoomOut.on('click', function () {
               viewer.setHfov(viewer.getHfov() + 10);
            });
            $zoomIn.on('click', function () {
               viewer.setHfov(viewer.getHfov() - 10);
            });
            $fullscreen.on('click', function () {
               viewer.toggleFullscreen();
            });


        })

    }
});